import React from "react";
var TableHeaderCell = function (props) {
    var id = props.id, style = props.style, className = props.className, children = props.children;
    return (React.createElement("th", { id: id, style: style, className: className }, children));
};
export default TableHeaderCell;
//# sourceMappingURL=DataTableHeadCell.js.map